export default __webpack_public_path__ + "static/media/lecture-dubbing-feature.99301b2f.webp";